import { Component, OnChanges, ChangeDetectionStrategy, Input, SimpleChanges } from '@angular/core';
import { CostChartItem } from './cost-chart.model';

const unitOfMeasureMap = {
    EUR: '€',
    SEK: 'Kr',
    h: 'h'
};

@Component({
    selector: 'app-cost-chart',
    templateUrl: './cost-chart.component.html',
    styleUrls: ['./cost-chart.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CostChartComponent implements OnChanges {
    @Input() costData: CostChartItem[];
    @Input() uom: string;
    @Input() chartTitle: string = '';
    @Input() chartYear: string = '';

    public maxValue: number = 0;
    public maxNegValue: number = 0;

    public get unitOfMeasure(): string {
        return unitOfMeasureMap[this.uom] || '';
    }

    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['costData']) {
            let tempMax = 0;
            let tempMaxNeg = 0;
            this.costData?.forEach(o => {
                if (o.value < 0) {
                    tempMaxNeg = o.value < tempMaxNeg ? o.value : tempMaxNeg;
                } else {
                    tempMax = o.value > tempMax ? o.value : tempMax;
                }
            });

            this.maxValue = tempMax;
            this.maxNegValue = tempMaxNeg;
        }
    }
}
